import { ApplyType } from "./radioButtonsGroup";
import { t } from "../../../core/i18n/i18n";
import { PopupMessage } from "lego-gui-lib";
import { stringToColour } from "lego-gui-lib/lib/helpers/stringToColour";

export interface CalendarDto {
  year: number;
  month?: number;
  day?: number;
  dayOfWeek?: number;
  isClearing: boolean;
}

export const createPopupMessage = (
  date: any,
  dayType: string,
  isClearing: boolean,
  method: string
) => {
  const operationTypeTitle = isClearing
    ? "hns:calendarDayType:clearing"
    : "hns:calendarDayType:marking";
  const operationTypeText = isClearing
    ? "hns:calendarDayType:clear"
    : "hns:calendarDayType:mark";
  const selectedDate = date.toLocaleDateString("en-GB");
  const selectedWeekDay = date.toLocaleString("default", {
    weekday: "long"
  });
  const selectedMonth = date.toLocaleString("default", { month: "long" });
  const selectedYear = date.toLocaleString("default", {
    year: "numeric"
  });

  let popupMessage = t("hns:calendarDayType:popupMessageDay", {
    operationType: operationTypeText,
    dayType: isClearing ? "" : ": " + dayType,
    date: selectedDate
  })();
  let operationString = "hns:calendarDayType:singleDay";

  if (method == ApplyType.WD_MONTH) {
    operationString = "hns:calendarDayType:weekdaysOfCurrentMonth";
    popupMessage = t("hns:calendarDayType:popupMessageMonth", {
      operationType: operationTypeText,
      dayType: isClearing ? "" : ": " + dayType,
      weekdayName: selectedWeekDay,
      monthName: selectedMonth
    })();
  } else if (method == ApplyType.WD_YEAR) {
    operationString = "hns:calendarDayType:weekdaysOfCurrentYear";
    popupMessage = t("hns:calendarDayType:popupMessageYear", {
      operationType: operationTypeText,
      dayType: isClearing ? "" : ": " + dayType,
      weekdayName: selectedWeekDay,
      year: selectedYear
    })();
  }

  const message: PopupMessage = {
    title: t("hns:calendarDayType:popupTitle", {
      operationType: operationTypeTitle,
      operation: operationString
    })(),
    content: popupMessage
  };

  return message;
};

export const createCalendarDto = (
  date: any,
  method: string,
  isClearing: boolean
) => {
  const calendardto: CalendarDto = {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate(),
    dayOfWeek: date.getDay() == 0 ? 7 : date.getDay(),
    isClearing: isClearing
  };

  if (method == ApplyType.WD_MONTH) {
    calendardto.day = undefined;
  } else if (method == ApplyType.WD_YEAR) {
    calendardto.day = undefined;
    calendardto.month = undefined;
  }
  return calendardto;
};

export const createColorsMap = (resultMap: Map<string, string[]>) => {
  const colorsMap = new Map();
  for (const [key, value] of Object.entries(resultMap)) {
    const generatedColor = stringToColour(key);
    value.forEach((date: string) => {
      colorsMap.set(date, generatedColor);
    });
  }
  return colorsMap;
};

export const createSelectedArray = (resultMap: Map<string, string[]>) => {
  const selected: Date[] = [];
  for (const [key, value] of Object.entries(resultMap)) {
    value.forEach((date: string) => {
      selected.push(new Date(date));
    });
  }
  return selected;
};

export const getCalendarTitle = () =>
  t("common:edit", { domain: "hns:calendar:domain" })();
export const getAddFieldPlaceholder = () =>
  t("hns:calendarDayType:addFieldPlaceholder")();
